export default "__VITE_ASSET__BpiYyBOH__"